import axios from 'axios';
import { omit } from 'ramda';

import * as urls from 'constants/urls';

export const postLogin = ({ payload }) => (
    axios.post(urls.LOGIN.stringify(), {}, { auth: payload })
);

export const postPasswordReset = ({ payload }) => (
    axios.post(urls.PASSWORD_RESET.stringify(), payload)
);

export const patchPasswordReset = ({ payload }) => (
    axios.patch(urls.PASSWORD_RESET.stringify(), payload)
);

export const postUser = ({ payload }, url = urls.USER.stringify()) => {
    const bodyFormData = new FormData();
    const form = omit(['file', 'files', 'updated_at', 'created_at', 'is_confirmed'], payload.user);

    if (payload.user.file) {
        bodyFormData.set('files[]', payload.user.file);
        form.files_ids = undefined;
    }

    bodyFormData.set('data', JSON.stringify({ user: form }));
    return axios.post(url, bodyFormData, {
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    });
};
export const patchUser = (action) => postUser(action, urls.USER_UPDATE.stringify());

export const getUser = () => axios.get(urls.USER.stringify());

export const getUserBilling = () => axios.get(urls.USER_BILLING.stringify());
export const postUserBilling = ({ payload }) => axios.post(urls.USER_BILLING.stringify(), {
    billing_info: omit(['isIndividual'], payload)
});
export const patchUserBilling = ({ payload }) => axios.patch(urls.USER_BILLING.stringify(), {
    billing_info: omit(['isIndividual'], payload)
});

export const getDictionaries = () => axios.get(urls.DICTIONARIES.stringify());
export const getDistributors = () => axios.get(urls.DISTRIBUTORS.stringify());
export const sendFeedback = ({ payload }) => axios.patch(urls.FEEDBACK.stringify(), {

    "email": payload.email,
    "message": payload.message

});

export const getNotifications = () => axios.get(urls.NOTIFICATIONS.stringify());
export const markNotifications = () => axios.get(urls.NOTIFICATIONS_MARK.stringify());

export const addCheck = ({payload}) => {
    const bodyFormData = new FormData();

    if (payload.check) {
        bodyFormData.append('file', payload.check);
    }

    return axios.post(urls.ADD_CHECK.stringify({application: payload.application}), bodyFormData, {
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    });
}

export const getBonuses = () => {
    return axios.get(urls.BONUSES.stringify());
}

export const sendSms = () => {
    return axios.get(urls.SMS.stringify());
}

export const getAllApplications = () => {
    return axios.get(urls.ALL_APPLICATIONS.stringify());
}


// WEBPACK FOOTER //
// ./src/actions/httpHandlers/userHandlers.js